// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { FormHelperText, Typography } from '@mui/material';
//
import { UploadAvatar, Upload, UploadBox, UploadProps } from '../upload';

// ----------------------------------------------------------------------

interface Props extends Omit<UploadProps, 'file'> {
  name: string;
  multiple?: boolean;
}

// ----------------------------------------------------------------------

export function RHFUploadAvatar({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <UploadAvatar
            accept="image/*"
            error={!!error}
            file={field.value}
            {...other}
          />

          {!!error && (
            <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUploadBox({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <UploadBox files={field.value} error={!!error} {...other} />
      )}
    />
  );
}

// ----------------------------------------------------------------------

export function RHFUpload({ name, multiple, helperText, ...other }: Props) {
  const { control } = useFormContext();
  let thumbnail = (other.thumbnail) ? other.thumbnail : false
  let accept = (other.accept) ? other.accept : undefined

  let title = other.title
  if (!helperText) {
    let label = "Tous types de fichier autorisés"
    if (accept) {
      if (accept === "image/*") {
        label = "Formats autorisés : *.jpeg, *.jpg, *.png, *.gif"
        title = "Choisir ou déposer un fichier image"
      }
    }

    helperText = <Typography
      variant="caption"
      sx={{
        mt: 0,
        mx: "auto",
        display: "block",
        textAlign: "center",
        color: "text.secondary",
      }}
    >
      {label}
    </Typography>
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) =>
        multiple ? (
          <Upload
            multiple
            accept={accept}
            thumbnail={thumbnail}
            files={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            title={title}
            {...other}
          />
        ) : (
          <Upload
            accept={accept}
            thumbnail={thumbnail}
            file={field.value}
            error={!!error}
            helperText={
              (!!error || helperText) && (
                <FormHelperText error={!!error} sx={{ px: 2 }}>
                  {error ? error?.message : helperText}
                </FormHelperText>
              )
            }
            title={title}
            {...other}
          />
        )
      }
    />
  );
}
